export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "Log på",
    "login.form.hint.user": "Logon",
    "login.form.hint.password": "Adgangskode",
    "login.form.checkbox.remember-me": "Husk mig",
    "login.form.button.sign-in": "Log på",
    "login.form.message.invalid-user-credentials": "Logon eller adgangskode er forkert",
    "login.form.message.user-required": "Angiv et logon",
    "login.form.message.password-required": "Angiv en adgangskode",
    "login.form.button.forgot-password": "Glemt adgangskode?",
    "error.root-admin-login.title": "Fejl 403 – forbudt",
    "error.root-admin-login.message": "Du er logget på som en skrivebeskyttet administrator. Hvis du vil have adgang til Web Recovery-konsollen, skal du i stedet logge på kundelejer eller administrator"
};
